import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInitService } from './services/app-init.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

export function initApp(appInitService: AppInitService) {
    return (): Promise<any> => {
        return appInitService.init();
    }
}

registerLocaleData(localeIt);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    
    constructor(
        private snackBar: MatSnackBar,
        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            if ([429].includes(err.status)) {
                // too many requests
                this.snackBar.open("Spiacente troppe richieste, Riprovare più tardi.", 'Close', {
                    duration: 3000,
                    // verticalPosition: 'top',
                    panelClass: 'generic-notification'
                });
            }

            if ([0].includes(err.status)) {                
                this.snackBar.open("Spiacente si è verificato un errore. Riprovare più tardi.", 'Close', {
                    duration: 3000,
                    // verticalPosition: 'top',
                    panelClass: 'generic-notification'
                });
            }

            return throwError(() => err);
        }))
    }
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatSnackBarModule,
        MatDialogModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initApp,
            deps: [AppInitService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: "it-IT" // forced IT locale
        },
        HttpClient,
        {
            provide: Window,
            useValue: window,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
